import React from "react";
const PRERENDER_TEXTS = require("../../../../../../prerender_base.js");

function ItogThiaContestToFormatWeNeed(ContestItog) {
    try {
        return ContestItog.map(
            function (Contest,i) {
                return <tr key={+JSON.parse(Contest).Number+1}>
                    <td>{+JSON.parse(Contest).Number+1}</td>
                    <td className="TraderContestResultThisContestTableInPhone700Out">
                        {/*{(i <10) ? <a href={"https://files.fxbitcoin.org/ContestResults/"+JSON.parse(Contest).Link} target="_blank" rel="noopener noreferrer" >{JSON.parse(Contest).AccNumber}</a> : JSON.parse(Contest).AccNumber}*/}
                        <a href={"https://files.fxbitcoin.org/ContestResults/"+JSON.parse(Contest).Link} target="_blank" rel="noopener noreferrer" >{JSON.parse(Contest).AccNumber}</a>
                        <div className="TraderContestResultThisContestTableInPhone700">{JSON.parse(Contest).Country}</div>
                        <div className="TraderContestResultThisContestTableInPhone700">{JSON.parse(Contest).City}</div>
                    </td>
                    <td className="NoInPhone700">{JSON.parse(Contest).Country}</td>
                    <td className="NoInPhone700">{JSON.parse(Contest).City}</td>
                    <td>{JSON.parse(Contest).Balance}</td>
                </tr>
            }
        );
    } catch (e) {
console.log(e);
    }

}

function DefiniteContestResult(props) {
    function TextSource(info) {try {return <>{JSON.parse(PRERENDER_TEXTS['ContestInfo'][info.ArrIndex])[props.lang] ? JSON.parse(PRERENDER_TEXTS['ContestInfo'][info.ArrIndex])[props.lang] : '*' + info.children}</>} catch (err) {return <>*{info.children}</>}}
        const AllOrdersOfThisContest =  ItogThiaContestToFormatWeNeed(props.ContestInfo.Itog.split('---')); // Справа сделки - мы их преобразуем в нужный нам формат
        return (
                <div className="TraderContestResultThisContest">
                    <table className="TraderContestResultThisContestTable">
                        <thead>
                        <tr>
                            <th>№</th>
                            <th><TextSource ArrIndex= 'ContestInfo0020'>СЧЕТ</TextSource></th>
                            <th className="NoInPhone700"><TextSource ArrIndex= 'ContestInfo0030'>ГОРОД</TextSource></th>
                            <th className="NoInPhone700"><TextSource ArrIndex= 'ContestInfo0025'>СТРАНА</TextSource></th>
                            <th><TextSource ArrIndex= 'ContestInfo0035'>БАЛАНС</TextSource></th>
                        </tr>
                        </thead>
                        <tbody>
                        {AllOrdersOfThisContest}
                        </tbody>
                    </table>
                </div>
        )}

export default DefiniteContestResult